// 个人校验规则
const personalRules = {
  // 顶部
  partnerForm: [{ message: '请选择合作伙伴类别', trigger: ['blur', 'change'], required: true }],
  // taxpayerType: [{ required: true, message: '请选择纳税人分类', trigger: ['blur', 'change'] }],
  companyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  creditCode: [
    {
      required: false,
      message: window.vm.$t('cooperation.placeholder.creditCode'),
      trigger: ['blur', 'change'],
    },
    { min: 18, max: 18, message: '长度18个字符', trigger: ['blur', 'change'] },
  ],
  companyName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  departmentCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.departmentName'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerDepartment: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerDepartment'),
      trigger: ['blur', 'change'],
    },
  ],
  requestTime: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestTime'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerZhName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerZhName'),
      trigger: ['blur', 'change'],
    },
    { min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: ['blur', 'change'] },
  ],
  createBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.createBy'),
      trigger: ['blur', 'change'],
    },
  ],
  requestBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestBy'),
      trigger: ['blur', 'change'],
    },
  ],
  ifDomestic: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifDomestic'),
      trigger: ['blur', 'change'],
    },
  ],
  ifPersonalPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifPersonalPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  enterpriseType: [
    {
      required: true,
      message: '请选择企业类型',
      trigger: ['blur', 'change'],
    },
  ],
  ifCreditPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifCreditPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerType'),
      trigger: ['blur', 'change'],
    },
  ],
  searchCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.searchCode'),
      trigger: ['blur', 'change'],
    },
  ],
  tradeCurrency: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.tradeCurrency'),
      trigger: ['blur', 'change'],
    },
  ],
  identityNo: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.identityNo'),
      trigger: ['blur', 'change'],
      // pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
    },
  ],
  // province: [ // sxp 20210121 注释 省份
  //   { required: true, message: window.vm.$t('cooperation.placeholder.province'), trigger: ["blur", "change"] },
  // ],
  // city: [ // sxp 20210121 注释 城市
  //   { required: true, message: window.vm.$t('cooperation.placeholder.city'), trigger: ["blur", "change"] },
  // ],
  // streetAddress: [ // sxp 20210121 注释 街道地址
  //   { required: true, message: window.vm.$t('cooperation.placeholder.streetAddress'), trigger: ["blur", "change"] },
  // ],
  roomNo: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.roomNo'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerParentCompanyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerParentCompanyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  capacityLimitAmount: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.capacityLimitAmount'),
      trigger: ['blur', 'change'],
    },
  ],
  capacityLimitCurrencyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.currencyType'),
      trigger: ['blur', 'change'],
    },
  ],
  isRelatedParty: [{ required: true, message: '请选择是否关联方', trigger: ['blur', 'change'] }],
  legalEntityType: [
    // sxp add 20210121 法人类型
    {
      message: window.vm.$t('cooperation.placeholder.legalEntityType'),
      trigger: ['blur', 'change'],
    },
  ],
  // industryName: [
  //   // sxp add 20210121 行业
  //   {
  //     required: true,
  //     message: window.vm.$t('cooperation.placeholder.industryName'),
  //     trigger: ['blur', 'change'],
  //   },
  // ],
  province: [{ message: '请选择省', trigger: ['blur', 'change'] }],
  city: [{ message: '请选择市', trigger: ['blur', 'change'] }],
};
// 国内企业
const domesticEnterprisesRules = {
  // 顶部
  partnerForm: [{ message: '请选择合作伙伴类别', trigger: ['blur', 'change'], required: true }],

  // taxpayerType: [{ required: true, message: '请选择纳税人', trigger: ['blur', 'change'] }],
  companyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  companyName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyName'),
      trigger: ['blur', 'change'],
    },
  ],
  departmentCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.departmentName'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerDepartment: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerDepartment'),
      trigger: ['blur', 'change'],
    },
  ],
  requestTime: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestTime'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerZhName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerZhName'),
      trigger: ['blur', 'change'],
    },
    { min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: ['blur', 'change'] },
  ],
  createBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.createBy'),
      trigger: ['blur', 'change'],
    },
  ],
  requestBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestBy'),
      trigger: ['blur', 'change'],
    },
  ],
  ifDomestic: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifDomestic'),
      trigger: ['blur', 'change'],
    },
  ],
  ifCreditPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifCreditPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  ifPersonalPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifPersonalPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  enterpriseType: [
    {
      required: true,
      message: '请选择企业类型',
      trigger: ['blur', 'change'],
    },
  ],
  partnerType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerType'),
      trigger: ['blur', 'change'],
    },
  ],
  creditCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.creditCode'),
      trigger: ['blur', 'change'],
    },
    { min: 18, max: 18, message: '长度18个字符', trigger: ['blur', 'change'] },
  ],
  capacityLimitAmount: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.capacityLimitAmount'),
      trigger: ['blur', 'change'],
    },
  ],
  capacityLimitCurrencyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.currencyType'),
      trigger: ['blur', 'change'],
    },
  ],
  // invoiceAddress: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoiceAddress'), trigger: ["blur", "change"] },
  // ],
  // invoicePhone: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoicePhone'), trigger: ["blur", "change"] },
  // ],
  // invoiceBankName: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoiceBankName'), trigger: ["blur", "change"] },
  // ],
  // invoiceBankAccount: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoiceBankAccount'), trigger: ["blur", "change"] },
  // ],
  // legalPerson: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.legalPerson'), trigger: ["blur", "change"] },
  // ],
  // registeredAssets: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.registeredAssets'), trigger: ["blur", "change"] },
  // ],
  // currencyType: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.currencyType'), trigger: ["blur", "change"] },
  // ],
  // establishedDate: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.establishedDate'), trigger: ["blur", "change"] },
  // ],
  searchCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.searchCode'),
      trigger: ['blur', 'change'],
    },
  ],
  tradeCurrency: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.tradeCurrency'),
      trigger: ['blur', 'change'],
    },
  ],

  //新加字段
  establishedDate: [
    {
      required: true,
      message: '请输入成立日期',
      trigger: ['blur', 'change'],
    },
  ],
  registeredAssets: [
    {
      required: true,
      message: '请输入注册资本',
      trigger: ['blur', 'change'],
    },
  ],
  // actualAssets: [
  //   {
  //     required: true,
  //     message: '请输入实缴资本',
  //     trigger: ['blur', 'change'],
  //   },
  // ],
  invoiceAddress: [
    {
      required: true,
      message: '请输入开票地址',
      trigger: ['blur', 'change'],
    },
  ],
  invoicePhone: [
    {
      required: true,
      message: '请输入开票电话',
      trigger: ['blur', 'change'],
    },
  ],
  invoiceBankName: [
    {
      required: true,
      message: '请输入开票银行名称',
      trigger: ['blur', 'change'],
    },
  ], // 开票银行名称
  invoiceBankAccount: [
    {
      required: true,
      message: '请输入开票银行账号',
      trigger: ['blur', 'change'],
    },
  ], // 开票银行账号
  // enterpriseType: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.enterpriseType'), trigger: ["blur", "change"] },
  // ],
  taxType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.taxType'),
      trigger: ['blur', 'change'],
    },
  ],
  // postCode: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.postCode'), trigger: ["blur", "change"] },
  // ],
  // province: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.province'), trigger: ["blur", "change"] },
  // ],
  // city: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.city'), trigger: ["blur", "change"] },
  // ],
  // streetAddress: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.streetAddress'), trigger: ["blur", "change"] },
  // ],
  // roomNo: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.roomNo'), trigger: ["blur", "change"] },
  // ],
  partnerParentCompanyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerParentCompanyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  legalEntityType: [
    {
      // required: true,
      message: window.vm.$t('cooperation.placeholder.legalEntityType'),
      trigger: ['blur', 'change'],
    },
  ],
  legalPerson: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.legalPerson'),
      trigger: ['blur', 'change'],
    },
  ],
  // industryName: [
  //   {
  //     required: true,
  //     message: window.vm.$t('cooperation.placeholder.industryName'),
  //     trigger: ['blur', 'change'],
  //   },
  // ],
  isRelatedParty: [{ required: true, message: '请选择是否关联方', trigger: ['blur', 'change'] }],
  province: [{ required: true, message: '请选择省', trigger: ['blur', 'change'] }],
  city: [{ required: true, message: '请选择市', trigger: ['blur', 'change'] }],
};
// 国内企业 (中国、中国保税区、中国香港、中国台湾、中国澳门)
const domesticEnterprisesCNRules = {
  taxType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.taxType'),
      trigger: ['blur', 'change'],
    },
  ],
  // 顶部
  partnerForm: [{ message: '请选择合作伙伴类别', trigger: ['blur', 'change'], required: true }],
  // taxpayerType: [{ required: true, message: '请选择纳税人', trigger: ['blur', 'change'] }],
  companyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  companyName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyName'),
      trigger: ['blur', 'change'],
    },
  ],
  departmentCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.departmentName'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerDepartment: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerDepartment'),
      trigger: ['blur', 'change'],
    },
  ],
  requestTime: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestTime'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerZhName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerZhName'),
      trigger: ['blur', 'change'],
    },
    { min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: ['blur', 'change'] },
  ],
  createBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.createBy'),
      trigger: ['blur', 'change'],
    },
  ],
  requestBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestBy'),
      trigger: ['blur', 'change'],
    },
  ],
  ifDomestic: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifDomestic'),
      trigger: ['blur', 'change'],
    },
  ],
  ifCreditPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifCreditPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  ifPersonalPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifPersonalPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  enterpriseType: [
    {
      required: true,
      message: '请选择企业类型',
      trigger: ['blur', 'change'],
    },
  ],
  partnerType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerType'),
      trigger: ['blur', 'change'],
    },
  ],
  capacityLimitAmount: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.capacityLimitAmount'),
      trigger: ['blur', 'change'],
    },
  ],
  capacityLimitCurrencyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.currencyType'),
      trigger: ['blur', 'change'],
    },
  ],

  searchCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.searchCode'),
      trigger: ['blur', 'change'],
    },
  ],
  tradeCurrency: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.tradeCurrency'),
      trigger: ['blur', 'change'],
    },
  ],

  partnerParentCompanyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerParentCompanyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  legalEntityType: [
    {
      // required: true,
      message: window.vm.$t('cooperation.placeholder.legalEntityType'),
      trigger: ['blur', 'change'],
    },
  ],
  legalPerson: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.legalPerson'),
      trigger: ['blur', 'change'],
    },
  ],
  // industryName: [
  //   {
  //     required: true,
  //     message: window.vm.$t('cooperation.placeholder.industryName'),
  //     trigger: ['blur', 'change'],
  //   },
  // ],
  isRelatedParty: [{ required: true, message: '请选择是否关联方', trigger: ['blur', 'change'] }],
  province: [{ required: true, message: '请选择省', trigger: ['blur', 'change'] }],
  city: [{ required: true, message: '请选择市', trigger: ['blur', 'change'] }],
  //新加字段
  establishedDate: [
    {
      required: true,
      message: '请输入成立日期',
      trigger: ['blur', 'change'],
    },
  ],
  registeredAssets: [
    {
      required: true,
      message: '请输入注册资本',
      trigger: ['blur', 'change'],
    },
  ],
  // actualAssets: [
  //   {
  //     required: true,
  //     message: '请输入实缴资本',
  //     trigger: ['blur', 'change'],
  //   },
  // ],
  invoiceAddress: [
    {
      required: true,
      message: '请输入开票地址',
      trigger: ['blur', 'change'],
    },
  ],
  invoicePhone: [
    {
      required: true,
      message: '请输入开票电话',
      trigger: ['blur', 'change'],
    },
  ],
  invoiceBankName: [
    {
      required: true,
      message: '请输入开票银行名称',
      trigger: ['blur', 'change'],
    },
  ], // 开票银行名称
  invoiceBankAccount: [
    {
      required: true,
      message: '请输入开票银行账号',
      trigger: ['blur', 'change'],
    },
  ], // 开票银行账号
};
// 国外
const foreignRules = {
  taxType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.taxType'),
      trigger: ['blur', 'change'],
    },
  ],
  // 顶部
  partnerForm: [{ message: '请选择合作伙伴类别', trigger: ['blur', 'change'], required: true }],
  // taxpayerType: [{ required: true, message: '请选择纳税人', trigger: ['blur', 'change'] }],
  companyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  companyName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyName'),
      trigger: ['blur', 'change'],
    },
  ],
  departmentCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.departmentName'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerDepartment: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerDepartment'),
      trigger: ['blur', 'change'],
    },
  ],
  requestTime: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestTime'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerZhName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerZhName'),
      trigger: ['blur', 'change'],
    },
    { min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: ['blur', 'change'] },
  ],
  createBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.createBy'),
      trigger: ['blur', 'change'],
    },
  ],
  requestBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestBy'),
      trigger: ['blur', 'change'],
    },
  ],
  ifDomestic: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifDomestic'),
      trigger: ['blur', 'change'],
    },
  ],
  ifPersonalPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifPersonalPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  enterpriseType: [
    {
      required: true,
      message: '请选择企业类型',
      trigger: ['blur', 'change'],
    },
  ],
  ifCreditPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifCreditPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerType'),
      trigger: ['blur', 'change'],
    },
  ],
  searchCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.searchCode'),
      trigger: ['blur', 'change'],
    },
  ],
  tradeCurrency: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.tradeCurrency'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerParentCompanyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerParentCompanyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  capacityLimitAmount: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.capacityLimitAmount'),
      trigger: ['blur', 'change'],
    },
  ],
  capacityLimitCurrencyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.currencyType'),
      trigger: ['blur', 'change'],
    },
  ],
  isRelatedParty: [{ required: true, message: '请选择是否关联方', trigger: ['blur', 'change'] }],
  legalEntityType: [
    // sxp add 20210121 法人类型
    {
      // required: true,
      message: window.vm.$t('cooperation.placeholder.legalEntityType'),
      trigger: ['blur', 'change'],
    },
  ],
  // industryName: [
  //   // sxp add 20210121 行业
  //   {
  //     required: true,
  //     message: window.vm.$t('cooperation.placeholder.industryName'),
  //     trigger: ['blur', 'change'],
  //   },
  // ],
};
//国外企业
const foreignRulesPerson = {
  taxType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.taxType'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerForm: [{ message: '请选择合作伙伴类别', trigger: ['blur', 'change'], required: true }],
  // taxpayerType: [{ required: true, message: '请选择纳税人', trigger: ['blur', 'change'] }],
  companyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  companyName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyName'),
      trigger: ['blur', 'change'],
    },
  ],
  departmentCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.departmentName'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerDepartment: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerDepartment'),
      trigger: ['blur', 'change'],
    },
  ],
  requestTime: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestTime'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerZhName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerZhName'),
      trigger: ['blur', 'change'],
    },
    { min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: ['blur', 'change'] },
  ],
  createBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.createBy'),
      trigger: ['blur', 'change'],
    },
  ],
  requestBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestBy'),
      trigger: ['blur', 'change'],
    },
  ],
  ifDomestic: [
    {
      required: true,
      message: '请选择国家地区',
      trigger: ['blur', 'change'],
    },
  ],
  ifPersonalPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifPersonalPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  enterpriseType: [
    {
      required: true,
      message: '请选择企业类型',
      trigger: ['blur', 'change'],
    },
  ],
  ifCreditPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifCreditPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerType'),
      trigger: ['blur', 'change'],
    },
  ],
  searchCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.searchCode'),
      trigger: ['blur', 'change'],
    },
  ],
  tradeCurrency: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.tradeCurrency'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerParentCompanyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerParentCompanyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  capacityLimitAmount: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.capacityLimitAmount'),
      trigger: ['blur', 'change'],
    },
  ],
  capacityLimitCurrencyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.currencyType'),
      trigger: ['blur', 'change'],
    },
  ],
  isRelatedParty: [{ required: true, message: '请选择是否关联方', trigger: ['blur', 'change'] }],
  legalPerson: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.legalPerson'),
      trigger: ['blur', 'change'],
    },
  ],
  legalEntityType: [
    // sxp add 20210121 法人类型
    {
      // required: true,
      message: window.vm.$t('cooperation.placeholder.legalEntityType'),
      trigger: ['blur', 'change'],
    },
  ],
  // industryName: [
  //   // sxp add 20210121 行业
  //   {
  //     required: true,
  //     message: window.vm.$t('cooperation.placeholder.industryName'),
  //     trigger: ['blur', 'change'],
  //   },
  // ],
  //新加字段
  establishedDate: [
    {
      required: true,
      message: '请输入成立日期',
      trigger: ['blur', 'change'],
    },
  ],
  registeredAssets: [
    {
      required: true,
      message: '请输入注册资本',
      trigger: ['blur', 'change'],
    },
  ],
  // actualAssets: [
  //   {
  //     required: true,
  //     message: '请输入实缴资本',
  //     trigger: ['blur', 'change'],
  //   },
  // ],
  invoiceAddress: [
    {
      required: true,
      message: '请输入开票地址',
      trigger: ['blur', 'change'],
    },
  ],
  invoicePhone: [
    {
      required: true,
      message: '请输入开票电话',
      trigger: ['blur', 'change'],
    },
  ],
  invoiceBankName: [
    {
      required: true,
      message: '请输入开票银行名称',
      trigger: ['blur', 'change'],
    },
  ], // 开票银行名称
  invoiceBankAccount: [
    {
      required: true,
      message: '请输入开票银行账号',
      trigger: ['blur', 'change'],
    },
  ], // 开票银行账号
};
//国内个人+合作伙伴1
const personalRulesParter = {
  taxType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.taxType'),
      trigger: ['blur', 'change'],
    },
  ],
  // 顶部
  partnerForm: [{ message: '请选择合作伙伴类别', trigger: ['blur', 'change'], required: true }],
  // taxpayerType: [{ required: true, message: '请选择纳税人', trigger: ['blur', 'change'] }],
  companyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  companyName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  departmentCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.departmentName'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerDepartment: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerDepartment'),
      trigger: ['blur', 'change'],
    },
  ],
  requestTime: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestTime'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerZhName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerZhName'),
      trigger: ['blur', 'change'],
    },
    { min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: ['blur', 'change'] },
  ],
  createBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.createBy'),
      trigger: ['blur', 'change'],
    },
  ],
  requestBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestBy'),
      trigger: ['blur', 'change'],
    },
  ],
  ifDomestic: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifDomestic'),
      trigger: ['blur', 'change'],
    },
  ],
  ifPersonalPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifPersonalPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  enterpriseType: [
    {
      required: true,
      message: '请选择企业类型',
      trigger: ['blur', 'change'],
    },
  ],
  ifCreditPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifCreditPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerType'),
      trigger: ['blur', 'change'],
    },
  ],
  searchCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.searchCode'),
      trigger: ['blur', 'change'],
    },
  ],
  tradeCurrency: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.tradeCurrency'),
      trigger: ['blur', 'change'],
    },
  ],
  identityNo: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.identityNo'),
      trigger: ['blur', 'change'],
      // pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
    },
  ],

  legalEntityType: [
    {
      message: window.vm.$t('cooperation.placeholder.legalEntityType'),
      trigger: ['blur', 'change'],
    },
  ],
  // province: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.province'), trigger: ["blur", "change"] },
  // ],
  // city: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.city'), trigger: ["blur", "change"] },
  // ],
  // streetAddress: [ // sxp 20210121 注释 街道地址
  //   { required: true, message: window.vm.$t('cooperation.placeholder.streetAddress'), trigger: ["blur", "change"] },
  // ],
  roomNo: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.roomNo'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerParentCompanyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerParentCompanyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  capacityLimitAmount: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.capacityLimitAmount'),
      trigger: ['blur', 'change'],
    },
  ],
  capacityLimitCurrencyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.currencyType'),
      trigger: ['blur', 'change'],
    },
  ],
  isRelatedParty: [{ required: true, message: '请选择是否关联方', trigger: ['blur', 'change'] }],
  // invoiceAddress: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoiceAddress'), trigger: ["blur", "change"] },
  // ],
  // invoicePhone: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoicePhone'), trigger: ["blur", "change"] },
  // ],
  // invoiceBankName: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoiceBankName'), trigger: ["blur", "change"] },
  // ],
  // invoiceBankAccount: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoiceBankAccount'), trigger: ["blur", "change"] },
  // ],
  // industryName: [
  //   // sxp add 20210121 行业
  //   {
  //     required: true,
  //     message: window.vm.$t('cooperation.placeholder.industryName'),
  //     trigger: ['blur', 'change'],
  //   },
  // ],
  province: [{ required: true, message: '请选择省', trigger: ['blur', 'change'] }],
  city: [{ required: true, message: '请选择市', trigger: ['blur', 'change'] }],
};

export const deliverRules = {
  abbreviation: [
    {
      required: true,
      message: '请填写合作伙伴简称',
      trigger: ['blur', 'change'],
    },
    { min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: ['blur', 'change'] },
  ],
  delivererIdDurationStart: [
    {
      message: '请填写投送人身份证期限',
      trigger: ['blur', 'change'],
    },
  ],
  delivererIdDurationEnd: [
    {
      message: '请填写投送人身份证期限',
      trigger: ['blur', 'change'],
    },
  ],
  delivererName: [
    {
      required: true,
      message: '请填写投送人姓名',
      trigger: ['blur', 'change'],
    },
  ],
  delivererPhone: [
    {
      required: true,
      message: '请填写投送人电话',

      trigger: ['blur', 'change'],
    },
    {
      validator: function (rule, value, callback) {
        if (/^1[34578]\d{9}$/.test(value) == false) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      },
    },
  ],
  delivererIdNo: [
    {
      required: true,
      message: '请填写投送人身份证号',
      trigger: ['blur', 'change'],
      pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
    },
  ],
};

//国内企业+合作伙伴
const domesticEnterprisesRulesParter = {
  taxType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.taxType'),
      trigger: ['blur', 'change'],
    },
  ],
  // 顶部
  partnerForm: [{ message: '请选择合作伙伴类别', trigger: ['blur', 'change'], required: true }],

  // taxpayerType: [{ required: true, message: '请选择纳税人', trigger: ['blur', 'change'] }],
  companyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  companyName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyName'),
      trigger: ['blur', 'change'],
    },
  ],
  departmentCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.departmentName'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerDepartment: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerDepartment'),
      trigger: ['blur', 'change'],
    },
  ],
  requestTime: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestTime'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerZhName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerZhName'),
      trigger: ['blur', 'change'],
    },
    { min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: ['blur', 'change'] },
  ],
  createBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.createBy'),
      trigger: ['blur', 'change'],
    },
  ],
  requestBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestBy'),
      trigger: ['blur', 'change'],
    },
  ],
  ifDomestic: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifDomestic'),
      trigger: ['blur', 'change'],
    },
  ],
  ifCreditPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifCreditPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  ifPersonalPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifPersonalPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  enterpriseType: [
    {
      required: true,
      message: '请选择企业类型',
      trigger: ['blur', 'change'],
    },
  ],
  partnerType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerType'),
      trigger: ['blur', 'change'],
    },
  ],
  creditCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.creditCode'),
      trigger: ['blur', 'change'],
    },
    { min: 18, max: 18, message: '长度18个字符', trigger: ['blur', 'change'] },
  ],
  capacityLimitAmount: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.capacityLimitAmount'),
      trigger: ['blur', 'change'],
    },
  ],
  capacityLimitCurrencyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.currencyType'),
      trigger: ['blur', 'change'],
    },
  ],
  // invoiceAddress: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoiceAddress'), trigger: ["blur", "change"] },
  // ],
  // invoicePhone: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoicePhone'), trigger: ["blur", "change"] },
  // ],
  // invoiceBankName: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoiceBankName'), trigger: ["blur", "change"] },
  // ],
  // invoiceBankAccount: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoiceBankAccount'), trigger: ["blur", "change"] },
  // ],
  // legalPerson: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.legalPerson'), trigger: ["blur", "change"] },
  // ],
  // registeredAssets: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.registeredAssets'), trigger: ["blur", "change"] },
  // ],
  // currencyType: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.currencyType'), trigger: ["blur", "change"] },
  // ],
  // establishedDate: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.establishedDate'), trigger: ["blur", "change"] },
  // ],
  searchCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.searchCode'),
      trigger: ['blur', 'change'],
    },
  ],
  tradeCurrency: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.tradeCurrency'),
      trigger: ['blur', 'change'],
    },
  ],
  invoiceAddress: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.invoiceAddress'),
      trigger: ['blur', 'change'],
    },
  ],
  invoicePhone: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.invoicePhone'),
      trigger: ['blur', 'change'],
    },
  ],
  invoiceBankName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.invoiceBankName'),
      trigger: ['blur', 'change'],
    },
  ],
  invoiceBankAccount: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.invoiceBankAccount'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerParentCompanyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerParentCompanyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  legalEntityType: [
    {
      // required: true,
      message: window.vm.$t('cooperation.placeholder.legalEntityType'),
      trigger: ['blur', 'change'],
    },
  ],
  legalPerson: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.legalPerson'),
      trigger: ['blur', 'change'],
    },
  ],
  // industryName: [
  //   {
  //     required: true,
  //     message: window.vm.$t('cooperation.placeholder.industryName'),
  //     trigger: ['blur', 'change'],
  //   },
  // ],
  isRelatedParty: [{ required: true, message: '请选择是否关联方', trigger: ['blur', 'change'] }],
  province: [{ required: true, message: '请选择省', trigger: ['blur', 'change'] }],
  city: [{ required: true, message: '请选择市', trigger: ['blur', 'change'] }],
  //新加字段
  establishedDate: [
    {
      required: true,
      message: '请输入成立日期',
      trigger: ['blur', 'change'],
    },
  ],
  registeredAssets: [
    {
      required: true,
      message: '请输入注册资本',
      trigger: ['blur', 'change'],
    },
  ],
  // actualAssets: [
  //   {
  //     required: true,
  //     message: '请输入实缴资本',
  //     trigger: ['blur', 'change'],
  //   },
  // ], // 开票银行账号
};
//国外+合作伙伴
const foreignRulesParter = {
  taxType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.taxType'),
      trigger: ['blur', 'change'],
    },
  ],
  // 顶部
  partnerForm: [{ message: '请选择合作伙伴类别', trigger: ['blur', 'change'], required: true }],
  // taxpayerType: [{ required: true, message: '请选择纳税人', trigger: ['blur', 'change'] }],
  companyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  companyName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyName'),
      trigger: ['blur', 'change'],
    },
  ],
  departmentCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.departmentName'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerDepartment: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerDepartment'),
      trigger: ['blur', 'change'],
    },
  ],
  requestTime: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestTime'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerZhName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerZhName'),
      trigger: ['blur', 'change'],
    },
    { min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: ['blur', 'change'] },
  ],
  createBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.createBy'),
      trigger: ['blur', 'change'],
    },
  ],
  requestBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestBy'),
      trigger: ['blur', 'change'],
    },
  ],
  ifDomestic: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifDomestic'),
      trigger: ['blur', 'change'],
    },
  ],
  ifPersonalPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifPersonalPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  enterpriseType: [
    {
      required: true,
      message: '请选择企业类型',
      trigger: ['blur', 'change'],
    },
  ],
  ifCreditPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifCreditPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerType'),
      trigger: ['blur', 'change'],
    },
  ],
  searchCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.searchCode'),
      trigger: ['blur', 'change'],
    },
  ],
  tradeCurrency: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.tradeCurrency'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerParentCompanyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerParentCompanyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  capacityLimitAmount: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.capacityLimitAmount'),
      trigger: ['blur', 'change'],
    },
  ],
  capacityLimitCurrencyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.currencyType'),
      trigger: ['blur', 'change'],
    },
  ],
  isRelatedParty: [{ required: true, message: '请选择是否关联方', trigger: ['blur', 'change'] }],
  legalEntityType: [
    {
      // required: true,
      message: window.vm.$t('cooperation.placeholder.legalEntityType'),
      trigger: ['blur', 'change'],
    },
  ],
  // industryName: [
  //   // sxp add 20210121 行业
  //   {
  //     required: true,
  //     message: window.vm.$t('cooperation.placeholder.industryName'),
  //     trigger: ['blur', 'change'],
  //   },
  // ],
  // invoiceAddress: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoiceAddress'), trigger: ["blur", "change"] },
  // ],
  // invoicePhone: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoicePhone'), trigger: ["blur", "change"] },
  // ],
  // invoiceBankName: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoiceBankName'), trigger: ["blur", "change"] },
  // ],
  // invoiceBankAccount: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoiceBankAccount'), trigger: ["blur", "change"] },
  // ],
};
//国外合作伙伴+企业
const foreignRulesParterPerson = {
  taxType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.taxType'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerForm: [{ message: '请选择合作伙伴类别', trigger: ['blur', 'change'], required: true }],
  // taxpayerType: [{ required: true, message: '请选择纳税人', trigger: ['blur', 'change'] }],
  companyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  companyName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.companyName'),
      trigger: ['blur', 'change'],
    },
  ],
  departmentCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.departmentName'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerDepartment: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerDepartment'),
      trigger: ['blur', 'change'],
    },
  ],
  requestTime: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestTime'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerZhName: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerZhName'),
      trigger: ['blur', 'change'],
    },
    { min: 1, max: 128, message: '长度在 1 到 128 个字符', trigger: ['blur', 'change'] },
  ],
  createBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.createBy'),
      trigger: ['blur', 'change'],
    },
  ],
  requestBy: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.requestBy'),
      trigger: ['blur', 'change'],
    },
  ],
  ifDomestic: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifDomestic'),
      trigger: ['blur', 'change'],
    },
  ],
  ifPersonalPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifPersonalPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  enterpriseType: [
    {
      required: true,
      message: '请选择企业类型',
      trigger: ['blur', 'change'],
    },
  ],
  ifCreditPartner: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.ifCreditPartner'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerType: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerType'),
      trigger: ['blur', 'change'],
    },
  ],
  searchCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.searchCode'),
      trigger: ['blur', 'change'],
    },
  ],
  tradeCurrency: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.tradeCurrency'),
      trigger: ['blur', 'change'],
    },
  ],
  partnerParentCompanyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.partnerParentCompanyCode'),
      trigger: ['blur', 'change'],
    },
  ],
  capacityLimitAmount: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.capacityLimitAmount'),
      trigger: ['blur', 'change'],
    },
  ],
  capacityLimitCurrencyCode: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.currencyType'),
      trigger: ['blur', 'change'],
    },
  ],
  isRelatedParty: [{ required: true, message: '请选择是否关联方', trigger: ['blur', 'change'] }],
  legalPerson: [
    {
      required: true,
      message: window.vm.$t('cooperation.placeholder.legalPerson'),
      trigger: ['blur', 'change'],
    },
  ],
  legalEntityType: [
    // sxp add 20210121 法人类型
    {
      // required: true,
      message: window.vm.$t('cooperation.placeholder.legalEntityType'),
      trigger: ['blur', 'change'],
    },
  ],
  // industryName: [
  //   // sxp add 20210121 行业
  //   {
  //     required: true,
  //     message: window.vm.$t('cooperation.placeholder.industryName'),
  //     trigger: ['blur', 'change'],
  //   },
  // ],
  // invoiceAddress: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoiceAddress'), trigger: ["blur", "change"] },
  // ],
  // invoicePhone: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoicePhone'), trigger: ["blur", "change"] },
  // ],
  // invoiceBankName: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoiceBankName'), trigger: ["blur", "change"] },
  // ],
  // invoiceBankAccount: [
  //   { required: true, message: window.vm.$t('cooperation.placeholder.invoiceBankAccount'), trigger: ["blur", "change"] },
  // ],
};
// hr
const hrRule = [
  {
    required: true,
    message: window.vm.$t('cooperation.placeholder.personnelIdentificationNumber'),
    trigger: ['blur', 'change'],
  },
];
// 销售数据对账科目校验规则
const sellSubjectRule = [
  {
    required: true,
    message: window.vm.$t('cooperation.placeholder.sellReconciliationSubject'),
    trigger: ['blur', 'change'],
  },
];
// 采购数据对账科目校验规则
const purchaseSubjectRule = [
  {
    required: true,
    message: window.vm.$t('cooperation.placeholder.procurementReconciliationSubject'),
    trigger: ['blur', 'change'],
  },
];

export {
  personalRules,
  domesticEnterprisesRules,
  domesticEnterprisesCNRules,
  foreignRules,
  hrRule,
  sellSubjectRule,
  foreignRulesParterPerson,
  foreignRulesPerson,
  purchaseSubjectRule,
  personalRulesParter,
  domesticEnterprisesRulesParter,
  foreignRulesParter,
};
